import { Button, FlexBox, Logo } from '@fable/components'
import { css, useTheme } from '@fable/theme'
import { ShareObjectType } from '@fable/types'
import AnchorLink from 'react-anchor-link-smooth-scroll'
import { useShareObject } from './useShareObject'

interface Props {
  id: string
  type: ShareObjectType
}

export const SharePageHeader = ({ id, type }: Props) => {
  const { colors, mediaQueries } = useTheme()
  const { onClickCta } = useShareObject()
  const bannerInView = false

  return (
    <>
      <span
        id="top"
        className={css`
          display: block;
          width: 100%;
          height: 60px;
        `}
      />
      <FlexBox
        className={css`
          padding: 0 24px;
          position: fixed;
          inset: ${bannerInView ? '64px' : 0} auto auto 0;
          width: 100%;
          height: 60px;
          background: ${colors.uiWhite};
          box-shadow: 0px 1px 1px 0px #ededed;
          z-index: 999;
        `}
        justifyContent="space-between"
        alignItems="center"
      >
        <AnchorLink href="#top">
          <Logo
            className={css`
              svg {
                width: 98px;
                ${mediaQueries.mobileL} {
                  width: 118px;
                }
              }
            `}
          />
        </AnchorLink>
        <Button
          className={css`
            padding: 0 12px;
            width: auto;
            height: 40px;
            ${mediaQueries.mobileL} {
              padding: 0 17.5px;
            }
          `}
          onClick={() =>
            onClickCta({ id, type, cta: 'header', skipModalOnMobile: true })
          }
        >
          Get the app
        </Button>
      </FlexBox>
    </>
  )
}
